/*
* @Des 组件 基站组
* @Description
* @Author
* @Date 2021/8/17
*/
/* HTML */
<template>
	<div :class="{'table-item-box padding-l-none': true, 'max-box': !showTreeBoxFlag}" style="padding: 20px;">
		<section style="height: 100%;">

			 <!-- 主内容 start -->
			 <div :class="{'page-box': true, 'no-items': true, 'player-contral': true, 'track-playing': (playerFilters.playState == 'play')}">

			 	<!-- 地图 容器 -->
			 	<div class="map-box">
			 		<SubRaphaelMap ref="svgMap" :class="{'off': this.$checkEmpty(maps)}" :mapEleId="'svg_map_group'" />
			 		<div :class="{'none-map-item': true, 'off': !this.$checkEmpty(maps)}" >
			 			<img alt="暂无地图" title="暂无地图" src="@/static_dazzle/images/map_none.png" >
			 		</div>
			 	</div>
				
			 	<!-- 区域列表 start -->
			 	<div class="area-items-box" v-show="areas.length > 0">
			 		<ul>
			 			<li v-for="(item, index) in areas" 
			 				:key="index" 
			 				:class="{'on': item.areaId == filters.areaId}" 
			 				:title="item.label"
			 				@click="clickAreaRow(item)">{{item.label}}</li>
			 			<li v-if="this.$checkEmpty(areas)" title="暂无区域">暂无区域</li>
			 		</ul>
			 	</div>
			 	<!-- 区域列表 end -->
			 	
			 	<!-- 地图列表 start -->
			 	<div class="map-items-box" v-show="maps.length > 0">
			 		<ul>
			 			<li v-for="(item, index) in maps" 
			 				:key="index" 
			 				:class="{'on': item.mapId == filters.mapId}" 
			 				:title="item.mapName"
			 				@click="clickMapRow(item)">{{item.mapName}}</li>
			 			<li v-if="this.$checkEmpty(maps)" title="暂无地图">暂无地图</li>
			 		</ul>
			 	</div>
			 	<!-- 区域列表 end -->

			 	<!-- 操作按钮 start -->
			 	<div class="handle-btns-box">
			 		<el-button type="primary" :class="{'on': handleFilters.showBsFlag}" icon="iconfont el-icon-my_jizhanxinhao" size="mini" trigger="click" @click="toggleBsFlag()" title="显示/隐藏 基站" v-if="true" ></el-button>
			 	</div>
			 	<!-- 操作按钮 start -->
				
				<!-- 播放器 start -->
				<div class="player-contral-box">
					<div class="contral-items-box">
						
						<!-- 控制按钮 start -->
						<div class="contral-btns-box">
							<i v-show="playerFilters.playState=='pause'" @click="playTracks" class="iconfont el-icon-my_bofang" title="播放"></i>
							<i v-show="playerFilters.playState=='play'" @click="pauseTracks" class="iconfont el-icon-my_zantingtingzhi" title="暂停"></i>
							<i v-show="playerFilters.playState=='end'" @click="replayTracks" class="el-icon-refresh-left" title="重新播放"></i>
						</div>
						<!-- 控制按钮 end -->
						
						<!-- 事案件展示 start -->
						<span class="time-item-start">{{$moment(playerFilters.startTimeLong).format('YYYY-MM-DD HH:mm:ss')}}</span>
						<span class="time-item-curr">{{$moment(playerFilters.currentPlayTime).format('YYYY-MM-DD HH:mm:ss')}}</span>
						<span class="time-item-end">{{$moment(playerFilters.endTimeLong).format('YYYY-MM-DD HH:mm:ss')}}</span>
						<!-- 事案件展示 end -->
						
						<!-- 倍速 start -->
						<span class="speed-item-box" @click="changeSpeed">{{playerFilters.speed}}&nbsp;倍速</span>
						
						<!-- 滑块 start -->
						<div class="slider-item-box">
							<el-slider v-model="playerFilters.currMoveIndex" 
								:show-tooltip="false" 
								:format-tooltip="timestepToolTip" 
								:max="playerFilters.maxMoveIndex" 
								:min="playerFilters.minMoveIndex"
								@change="(val) => {sliderChange(val)}"></el-slider>
						</div>
						<!-- 滑块 end -->
						
					</div>
				</div>
				<!-- 播放器 end -->
				
			 </div>
			 <!-- 主内容 end -->
			 
		</section>
	</div>
</template>

/* JS */
<script>
    // 公共变量
    import GlobalVariable from '@/global/global-variable'
    // 公共方法
    import GlobalFun from '@/global/global-function'
    
    // API 组织结构
	  import ApiOam from "@/request/api-oam";
	
    // svg地图 组件
    import SubRaphaelMap from '@/components/SubRaphaelMap'

    export default {
        name: "BaseStationGroups",
        props: {
            /**
             * @Des 展示box
             * @Auth
             * @Date 2021/8/17
             */
            showTreeBoxFlag: {
                type: Boolean,
                default: function (){
                    return true
                }
            },
            /**
             * @Des 轨迹数据
             * @Auth
             * @Date 2021/8/17
             */
            trackObj: {
                type: Object,
                default: function (){
                    return {}
                }
            },
            /**
             * @Des 轨迹数据
             * @Auth
             * @Date 2021/8/17
             */
            trackInfos: {
                type: Array,
                default: function (){
                    return []
                }
            },
            /**
             * @Des 时间差值 ms
             * @Auth
             * @Date 2021/8/17
             */
            timeDiff: {
                type: Number,
                default: function (){
                    return 1000
                }
            },
            
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/8/17
         */
        components: {
            // svg地图 组件
            SubRaphaelMap,
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/8/17
         */
        data() {
            return {
                /**
	             * @Des filters
	             * @Auth
	             * @Date 2021/8/17
	             */
                filters: {
                    areaId: '',
                    mapId: '',
                },
                
                // 操作按钮
                handleFilters: {
                	// 显示/隐藏 基站
                	showBsFlag: true,
                },
                
                // svg elem
                mapSub: this.$refs.svgMap,
                // 地图组件 初始化完成
                mapSubInitFlag: false,
                // 初始化地图完成
                svgInitedFlag: false,
                // 组织结构 list
				orgList: [],
				// 地图 总list
				orgMaps: [],
                // 区域
                areas: [],
                // 地图
                maps: [],
                // 缓存  记录 区域信息
				map_list_areas: new this.HashMap(),
				// 缓存  记录 地图信息
				map_list_maps: new this.HashMap(),
				
				// 缓存  记录 轨迹信息
				map_track: new this.HashMap(),
				// 自动切换地图 flag
				autoChangeMapFlag: true,
				
				/**
				 * @Des playerFilters
				 * @Auth
				 * @Date 2021/8/17
				 */
				playerFilters: {
					// 播放状态
					playState: 'pause',
					
					// 倍速集合
					speeds: [1, 2, 4],
					// 倍速下标
					speedIndex: 0,
					// 倍速
					speed: 1,
					
					// 起始时间
					startTimeLong: 0,
					// 结束时间
					endTimeLong: 0,
					// 当前播放时间
					currentPlayTime: 0,
					
					// 播放条的最小值
					minMoveIndex: 0,
					// 播放条的最大值
					maxMoveIndex: 100,
					// 当前点下标
					currMoveIndex: 0,
					
					// 播放条延时计时器
					sliderTimeout: null,
					// 开始播放延时计时器
					startMoreTimeout: null,
				},
				
				// 轨迹数据
				trackInfo: {},
            }
        },
        /**
         * @Des 加载完成
         * @Auth
         * @Date 2021/8/17
         */
        mounted() {
        	// svg elem
            this.mapSub = this.$refs.svgMap;
            // 地图组件 初始化完成
			this.mapSubInitFlag = true,
            
            // 轨迹方法
            this.mapSub.setTrackFns({
            	creatStaticPel: this.creatStaticPel,
            	startMorePlay: () => {},//this.startMorePlay,
            });
            
            // 查询结构
			this.searchOrg();
        	
        	// 开启订阅消息
        	this.startSubscribes();
        },
        /**
         * @Des 加载
         * @Auth
         * @Date 2021/8/17
         */
        created() {
        	
        },
        /**
         * @Des 销毁
         * @Auth
         * @Date 2021/8/17
         */
        beforeDestroy() {
        	// 取消订阅消息
			this.endSubscribes();
			// 播放状态
			this.playerFilters.playState = 'pause';
			// 设置播放flag
			this.mapSub.setPlayFlag(false);
			
			// 关闭 timer
        	this.endTimers();
        },
        /**
         * @Des 销毁
         * @Auth
         * @Date 2021/8/17
         */
        destroyed() {
			// 销毁 svg地图
			this.mapSub.destroySvg();
			// 初始化地图完成
			this.svgInitedFlag = false;
        },
        methods: {
            /**
        	 * @Des 关闭 timer
        	 * @Auth
        	 * @Date
        	 */
        	endTimers() {
        		// 清除计时器
				if (this.playerFilters.sliderTimeout) {
					clearTimeout(this.playerFilters.sliderTimeout);
					this.playerFilters.sliderTimeout = null;
				}
				//	清除定时器
				if(this.playerFilters.startMoreTimeout != null) {
					clearTimeout(this.playerFilters.startMoreTimeout);
					this.playerFilters.startMoreTimeout = null;
				}
				
        	},
            //========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date 2021/8/23
			 */
			startSubscribes() {
				return false;
				// 订阅消息 人员轨迹数据
				this.sub_trackInfo = this.$pubsub.subscribe('trackInfo', (name, data) => {
					// 接收轨迹数据
					this.receiveTrackData(data);
				});
			},
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date 2021/8/23
			 */
			endSubscribes() {
				return false;
				//取消订阅 相关信息
				this.$pubsub.unsubscribe(this.sub_trackInfo);
			},
			//========================== 订阅消息 end ==========================
            
            // ======================================= 基站 start ============================================ \\
			/**
             * @Des 查询基站
             * @Auth
             * @Date 2021/11/17
             */
            searchBaseStation() {
				// 清除 图元
				this.mapSub.clearAllStations('destroy');
				
				// 展示基站
				if (!this.handleFilters.showBsFlag) return false;
				
				// 交互 参数
				let formData = {
					subsectionId: this.filters.areaId,
					mapId: this.filters.mapId,
					projectId: this.$store.state.currentProjectId
				};
				
				// 交互
				this.$request.postJsonRequest(ApiOam.Search_Uwb_Bs_Uri, formData).then(result => {
                    // 更新数据
                    this.baseStations = !this.$checkEmpty(result.rows) ? result.rows : [];

                    // 刷新地图图元 基站
                    this.refreshMapStations();

                }).catch(error => {
                    console.error('查询基站异常', ApiOam.Search_Uwb_Bs_Uri, error);
                })
            },
            /**
             * @Des 切换基站展示状态
             * @Auth
             * @Date 2021/11/17
             */
            toggleBsFlag() {
				// 展示基站
				this.handleFilters.showBsFlag = !this.handleFilters.showBsFlag;

				// 清除 图元
				this.mapSub.clearAllStations('destroy');

				// 查询 基站
				this.handleFilters.showBsFlag && this.searchBaseStation();
            },
			/**
			 * @Des 刷新地图图元 基站
			 * @Auth
			 * @Date 2021/11/17
			 */
			refreshMapStations() {
				// 展示基站
				if (!this.handleFilters.showBsFlag) return false;

				// 重新绘制
				this.baseStations.forEach((row, index) => {
					// 空值 跳过
					if (this.$checkEmpty(row)) return true;
                    row.index = index;
                    
                    let mapInfoMap = !this.$checkEmpty(row.mapInfoMap) ? Object.assign({}, row.mapInfoMap) : {};
                    // 空值 跳过
                    if (!mapInfoMap.hasOwnProperty(this.filters.mapId) || this.$checkEmpty(row.pointX) || this.$checkEmpty(row.pointY)) {
                    	return false;
                    }
                    
                    // 不在同一区域
                    if (row.subsectionId != this.filters.areaId) return false;
                    // 总览图 跳过
                    if (this.$checkEmpty(this.filters.mapId)) return false;
                    
                    // 绘制 基站
					this.mapSub.loadStationPosition(Object.assign({}, row));
					
                    return true;
                    // mapId
                    let mapIds = row.mapIds.split(',');
                    // pointXPxs
                    let pointXPxs = row.pointXPx.split(',');
                    // pointYPxs
                    let pointYPxs = row.pointYPx.split(',');
                    
                	let onIndex = mapIds.indexOf((this.filters.mapId).toString());
                    // 地图不匹配 跳过
                    if (onIndex == -1) return false;
                    
					// 绘制 基站
					this.mapSub.loadStationPosition(Object.assign({}, row, {pointXPx: parseFloat(pointXPxs[onIndex]), pointYPx: parseFloat(pointYPxs[onIndex])}));
				});
			},
			// ======================================= 基站 end ============================================ \\
            
            /**
             * @Des 查询 组织结构
             * @Auth
             * @Date 
             */
            searchOrg() {
                this.$request.postJsonRequest(ApiOam.Find_Org_Uri,{
                    projectId: this.$store.state.currentProjectId
                }).then(result => {
                    //console.log(result); return false;
                    // 组织结构 list
                    this.orgList = Object.assign([], result.data);
                    
                    let orgAreas = [];// 区域
                    let orgMaps = [];// 地图
                    // 缓存
					this.map_list_areas.clear();
                    // 缓存 区域
                    this.orgList.forEach((row, index) => {
                    	// 空值 跳过
                    	if (this.$checkEmpty(row)) return true;
                    	
                    	if (row.level == 2) {
                    		// 区域
                    		orgAreas.push(Object.assign({}, row.node, {label: row.node.areaName}));
                    		// 缓存
                    		this.map_list_areas.put(row.areaId, Object.assign({}, row.node, {label: row.node.areaName}));
                    	}
                    	if (row.level == 3) {
                    		// 地图
                    		orgMaps.push(Object.assign({}, row.node));
                    	}
                    });
                    
                    // 区域
                    this.areas = Object.assign([], orgAreas);
                    // 地图
                    this.orgMaps = Object.assign([], orgMaps);
                    
                    // 当前选中项
                    let currItem = this.getCurrItem(this.areas, this.filters.areaId, 'areaId');
                    // 切换区域
                    this.changeArea(currItem);
                }).catch(error => {
                    console.error('查询组织结构异常', ApiOam.Find_Org_Uri, error);
                })
            },
            /**
             * @Des 切换区域
             * @Auth
             * @Date 2021/8/6
             */
            changeArea(row) {
            	//console.log(row);
            	// filters
            	this.filters.areaId = Object.assign({areaId: '', mapId: ''}, row).areaId;
            	
            	// 查询地图
            	this.searchMaps();
            },
            
            /**
             * @Des 查询地图
             * @Auth
             * @Date 2021/8/6
             */
            searchMaps() {
                // 地图集合
                this.maps = [];
                // 缓存
                this.map_list_maps.clear();
                
                // 缓存 地图
                this.orgMaps.forEach((row, index) => {
                	// 空值 跳过
                	if (this.$checkEmpty(row)) return true;
                	
                	// 没有区域 || 地图处于当前区域
                	if (this.$checkEmpty(this.areas) || row.areaId == this.filters.areaId) {
                		let itemRow = Object.assign({}, row);
                		// 检索 当前区域
                		let currArea = this.map_list_areas.get(this.filters.areaId);
                		// 区域有地铁
                		if (!this.$checkEmpty(currArea) && currArea.hasMap == 1) {
                			itemRow.pStartPointX = currArea.startPointX;
                			itemRow.pStartPointY = currArea.startPointY;
                			itemRow.pStartPointZ = currArea.startPointZ;
                			itemRow.pHasMap = true;
                		}
                		// 缓存 地图
                		this.maps.push(Object.assign({}, itemRow));
                		// 缓存
                    	this.map_list_maps.put(row.mapId, Object.assign({}, itemRow));
                	}
                });
                
                // 当前选中项
                let currItem = this.getCurrItem(this.maps, this.filters.mapId, 'mapId');
                // 目标空值
                if (this.$checkEmpty(currItem)) {
                	// 检索 当前区域
                	let currArea = this.map_list_areas.get(this.filters.areaId);
                	if (!this.$checkEmpty(currArea) && !this.$checkEmpty(currArea.mapUrl)) {
                		// 初始化 svg地图
						//this.mapSub.initMap(Object.assign({}, currArea, {mapUrl: (GlobalVariable.BASE_PATH + row.mapUrl)}));
						this.mapSub.initMap(Object.assign({}, currArea, {mapUrl: ('data:image/png;base64,' + row.mapUrl), mapLevel: 1, tunnelPoints: currArea.tunnelPoints}));
		            	if (!this.svgInitedFlag) {
		            		// 初始化地图完成
		            		this.svgInitedFlag = true;
		            		// 接收轨迹数据
		            		this.receiveTrackData({user: this.trackObj, positionList: this.trackInfos});
		            	}
                	} else {
                		// 切换地图
                		this.changeMap(this.maps[0]);
                	}
                	return false;
                }
                // 切换地图
                this.changeMap(currItem);
            },
            /**
             * @Des 切换地图
             * @Auth
             * @Date 2021/8/6
             */
            changeMap(row) {
            	// 空值 中止
            	if (this.$checkEmpty(row)) {
	            	// filters
					this.filters.mapId = '';
            		// 更新数据
                    this.fences = [];
            		
            		// 销毁 svg地图
					this.mapSub.destroySvg();
            		return false;
            	};
            	
            	//console.log(row);
            	// filters
            	this.filters.mapId = Object.assign({areaId: '', mapId: ''}, row).mapId;
            	
            	// 初始化 svg地图
				//this.mapSub.initMap(Object.assign({}, row, {mapUrl: (GlobalVariable.BASE_PATH + row.mapUrl)}));
				this.mapSub.initMap(Object.assign({}, row, {mapUrl: ('data:image/png;base64,' + row.mapUrl), mapLevel: 2, tunnelPoints: row.tunnelPoints}));
            	if (!this.svgInitedFlag) {
            		// 初始化地图完成
            		this.svgInitedFlag = true;
            		// 接收轨迹数据
            		this.receiveTrackData({user: this.trackObj, positionList: this.trackInfos});
            	}
            	
            	// 查询基站
            	this.searchBaseStation();
            	
            },
            /**
             * @Des 当前选中项
             * @Auth
             * @Date 2021/8/6
             */
            getCurrItem(rows, onkey, key) {
            	// 空值 中止
            	if (this.$checkEmpty(rows)) return false;
            	
            	// onrow
            	let onRow = null;
            	// 遍历 检索
            	rows.forEach((row, index) => {
            		if (onkey == row[key]) {
            			onRow = row;
            		}
            	});
            	
            	return (onRow == null && key != 'mapId' ? rows[0] : onRow);
            },
            /**
             * @Des 点击切换区域
             * @Auth
             * @Date 2021/8/6
             */
            clickAreaRow(row) {
				if (this.playerFilters.playState == 'play') {
					// 正在播放轨迹 ，不可手动切换
					return false;
				}
				// filters
				this.filters.mapId = '';
            	// 切换区域
            	this.changeArea(row);
            },
            /**
             * @Des 点击切换地图
             * @Auth
             * @Date 2021/8/6
             */
			clickMapRow(row) {
				if (this.playerFilters.playState == 'play') {
					// 正在播放轨迹 ，不可手动切换
					return false;
				}
				// 切换地图
				this.changeMap(row);
			},
			
			/**
			 * @Des 接收数据
			 * @Auth
			 * @Date 2021/8/24
			 */
			receiveTrackData(data) {
				// 轨迹数据
				this.trackInfo = Object.assign({}, data);
				let user = data.user;
				let positionList = data.positionList;
				var trackRows = [];
				positionList.forEach((row, n) => {
	                // 最小时间
	                if(this.playerFilters.startTimeLong == 0 || row.t < this.playerFilters.startTimeLong){
	                	this.playerFilters.startTimeLong = Math.floor(row.t/1000)*1000;
	                }
	                // 最大时间
	                if(this.playerFilters.endTimeLong == 0 || row.t > this.playerFilters.endTimeLong){
	                    this.playerFilters.endTimeLong = Math.ceil(row.t/1000)*1000
	                }
	                
	                trackRows.push({
                	    x: row.rX,
                	    y: row.rY,
                	    t: row.t,
                	    state: row.state == 0 ? 0 : 'default',
                	    areaId: row.areaId,
                	    mapId: row.mapId,
                	    type: (user.typeId ? user.typeId : 1)
                	});
	            });
	            this.map_track.put(user.userId, {
	                bindingType: 1,
	                userName: user.userName,
	                no: user.userNo,
	                typeId: user.typeId,
	                type: (user.typeId ? user.typeId : 1),
	                groupId: user.groupId,
	                points: trackRows,
	                color: this.mapSub.getRandomColor()
	            });
	            
	            // 解析数据
				this.analysisTracks();
			},
			/**
			 * @Des 解析数据
			 * @Auth
			 * @Date 2021/8/24
			 */
			analysisTracks() {
				if(this.map_track.size() == 0){
			        // 没有轨迹数据
			        return;
			    }
				
				var mapId = '';
				var areaId = '';
				var hasNoPoints = true;
				// 根据 开始时间、结束时间 以及 坐标点集合时间范围 进行前后补点
			    this.map_track.keySet().forEach((key, n) => {
			        var row = this.map_track.get(key);
			        
			        // 非空值
			        if (hasNoPoints && !this.$checkEmpty(row.points)) {
			        	hasNoPoints = false;
			        }
			        
			        if (this.$checkEmpty(row.points)) return false;
			        
			        /*
			        let newPoints = getByBatch(row.points,this.playerFilters.startTimeLong, this.playerFilters.endTimeLong, this.timeDiff, true);
			        map_track.get(key)['points'] = newPoints;
			        mapId = !this.$checkEmpty(newPoints) ? newPoints[0].mapId : '';
			        */
					
					var _points = Object.assign([], row.points);// [].concat(row.points);
					var startPoint = _points[0];
					var endPoint = _points[_points.length - 1];
					if (startPoint.t > this.playerFilters.startTimeLong) {
						var slot_s = parseInt((startPoint.t - this.playerFilters.startTimeLong) / 1000);
						for(var i = 1; i <= slot_s; i++) {
							var _t = startPoint.t - i*1000;
							_points.unshift($.extend({}, startPoint, {t: _t}));
						}
					}
					if (endPoint.t < this.playerFilters.endTimeLong) {
						var slot_e = parseInt((this.playerFilters.endTimeLong - endPoint.t) / 1000);
						for(var j = 1; j <= slot_e; j++) {
							var _t = endPoint.t + j*1000;
							_points.push($.extend({}, endPoint, {t: _t}));
						}
					}
					
			        mapId = !this.$checkEmpty(_points) ? _points[0].mapId : '';
			        areaId = !this.$checkEmpty(_points) ? _points[0].areaId : '';
			        
			        row.points = _points;
			    });
			    
			    //	自动切换
				if (this.map_track.size() == 1){
					this.autoChangeMapFlag = true;
					if(!this.$checkEmpty(mapId) && mapId != this.filters.mapId){
						// 切换地图
						this.filters.mapId = mapId;
						
						if (this.filters.areaId != areaId) {
							// 切换区域
							this.filters.areaId = areaId;
							
							// 检索 当前区域
							let currArea = this.map_list_areas.get(this.filters.areaId);
							// 切换区域
							this.changeArea(currArea);
						} else {
							// 检索 当前地图
							let currMap = this.map_list_maps.get(this.filters.mapId);
							// 切换区域
							this.changeMap(currMap);
						}
                    	
					}
				} else {
					this.autoChangeMapFlag = false;
				}
				//	重置播放
				this.resetPlay();
			    
			    //空值 中止
			    if (hasNoPoints) {
			    	//$('.palyerBox').hide();
			        this.$message({
                        message: '暂无相关轨迹！',
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
			    	return false;
			    }
			    
			    this.playerFilters.currentPlayTime = this.playerFilters.startTimeLong;
			    this.playerFilters.currMoveIndex = 0;
			    this.playerFilters.maxMoveIndex = Math.ceil((this.playerFilters.endTimeLong - this.playerFilters.startTimeLong) / this.timeDiff);
			},
			/**
			 * @Des 重置播放
			 * @Auth
			 * @Date 2021/8/24
			 */
			resetPlay() {
			
				//停止播放
				this.playerFilters.playState = 'pause';
				// 设置播放flag
				this.mapSub.setPlayFlag(false);
				
				// 当前播放时间
				this.playerFilters.currentPlayTime = Math.floor(this.playerFilters.startTimeLong/1000) * 1000;
				
				// 设置播放条的最小值
				this.playerFilters.minMoveIndex = 0;
			
				// 设置播放条的最大值
				this.playerFilters.maxMoveIndex = Math.ceil((this.playerFilters.endTimeLong - this.playerFilters.startTimeLong)/this.timeDiff) -1;
				
				//	初始化播放条
				
				//	当前移动的位置
				this.playerFilters.currMoveIndex = this.playerFilters.minMoveIndex;
				
				//	显示播放条
				
				//	创建图元
				this.creatStaticPel();
			},
			/**
			 * @Des 创建静态图元
			 * @Auth
			 * @Date 2021/8/24
			 */
			creatStaticPel() {
				//清除定时器
				if(this.playerFilterssliderTimeout != null) {
					clearTimeout(this.playerFilterssliderTimeout);
					//this.playerFilterssliderTimeout = null;
				}
				//清除所有跟踪
				this.mapSub.clearTrackAll();
				//创建人员
				var flag = this.creatTimePointPeople();
				if(flag){
					if(this.playerFilters.currMoveIndex - this.playerFilters.minMoveIndex > 0){
						//创建线
						flag = this.creatTimePointLine();
					}
				}
				return true;
			},
			/**
			 * @Des 创建时间点人员
			 * @Auth
			 * @Date 2021/8/24
			 */
			creatTimePointPeople() {
				
				this.map_track.keySet().forEach((key, m) => {
					var row = this.map_track.get(key);
					// 空值 跳过
					if (this.$checkEmpty(row.points)) return true;
					
					/*if(this.playerFilters.currMoveIndex > this.playerFilters.maxMoveIndex){
						this.playerFilters.currMoveIndex = this.playerFilters.maxMoveIndex;
					}*/
					
					let currMoveIndex = this.playerFilters.currMoveIndex > this.playerFilters.maxMoveIndex ? this.playerFilters.maxMoveIndex : this.playerFilters.currMoveIndex;
					if (currMoveIndex == this.playerFilters.maxMoveIndex && this.$checkEmpty(row.points[currMoveIndex])) {
						currMoveIndex = row.points.length - 1;
					}
					// 当前播放时间
					this.playerFilters.currentPlayTime = row.points[currMoveIndex].t;
					
					var pImg = this.mapSub.getPeopleImage(row.points[this.playerFilters.currMoveIndex].type, row.points[this.playerFilters.currMoveIndex].state);
					var info = {
							userName: row.userName,
							userNo: row.userNo,
							color: row.color,
							showName: row.showName,
							img: pImg,
							point: {
								x: row.points[currMoveIndex].x,
								y: row.points[currMoveIndex].y,
								t: row.points[currMoveIndex].t,
								areaId: row.points[currMoveIndex].areaId,
								mapId: row.points[currMoveIndex].mapId,
							}
					}
					if(this.autoChangeMapFlag){
						if(this.filters.mapId != row.points[currMoveIndex].mapId){
							// 切换地图
							this.filters.mapId = row.points[currMoveIndex].mapId;
							
							let areaId = row.points[currMoveIndex].areaId;
							if (this.filters.areaId != areaId) {
								// 切换区域
								this.filters.areaId = areaId;
								
								// 检索 当前区域
								let currArea = this.map_list_areas.get(this.filters.areaId);
								// 切换区域
								this.changeArea(currArea);
							} else {
								// 检索 当前地图
								let currMap = this.map_list_maps.get(this.filters.mapId);
								// 切换区域
								this.changeMap(currMap);
							}
							
						}
					}
					this.mapSub.creatStaticPeople(key,info);
				});
				return true;
			},
			
			/**
			 * @Des 创建时间点轨迹线
			 * @Auth
			 * @Date 2021/8/24
			 */
			creatTimePointLine() {
				this.map_track.keySet().forEach((key, m) => {
					var row = this.map_track.get(key);
					var points = [];
					let continueFlag = true;
					row.points.forEach((r, n) => {
						if (!continueFlag) return false;
						
						points.push({
							x: row.points[n].x,
							y: row.points[n].y,
							mapId: row.points[n].mapId,
							areaId: row.points[n].areaId
						});
						if(row.points[n].t >= row.points[this.playerFilters.currMoveIndex].t){
							continueFlag = false;
							this.mapSub.drawStaticTrackLine(key,points,row.color,this.filters.mapId);
							return false;
						}
					});
				});
				return true;
			},
			
			/**
             * @Des 切换倍速
             * @Auth
             * @Date 2021/8/24
             */
			changeSpeed() {
				// 倍速下标
				this.playerFilters.speedIndex++;
				// 修正下标
				let index = this.playerFilters.speedIndex % this.playerFilters.speeds.length;
				// 倍速
				this.playerFilters.speed = this.playerFilters.speeds[index];
			},
			/**
             * @Des slider change
             * @Auth
             * @Date 2021/8/24
             */
			sliderChange(value) {
				//console.log('change', value);
			},
			/**
             * @Des slider 值改变
             * @Auth
             * @Date 2021/8/24
             */
			timestepToolTip(index) {
				if (this.playerFilters.sliderTimeout) {
					clearTimeout(this.playerFilters.sliderTimeout);
					this.playerFilters.sliderTimeout = null;
				}
				//console.log('timestepToolTip', index);
				
				// 地图组件初始化未完成 中止
				if (!this.mapSubInitFlag) {
					return false;
				}
				
				//自动改变
				if(this.playerFilters.currMoveIndex == this.playerFilters.maxMoveIndex || this.playerFilters.playState != 'play'){
					//绘制静态图元
					this.creatStaticPel();
					
					if (this.playerFilters.currMoveIndex >= this.playerFilters.maxMoveIndex) {
						//显示回放时间
						//this.playerFilters.currentPlayTime = Math.floor(this.playerFilters.endTimeLong/1000) * 1000;
						//	显示开始播放和重播
						this.playerFilters.playState = 'end';
						// 设置播放flag
						this.mapSub.setPlayFlag(false);
					}
					return false;
				}
				
				//当前移动到的时间
				var currMoveTime = this.playerFilters.startTimeLong + this.playerFilters.currMoveIndex * this.timeDiff;
				if(Math.floor( currMoveTime / 1000 ) != this.playerFilters.currentPlayTime / 1000){
					//显示回放时间
					this.playerFilters.currentPlayTime = Math.floor(currMoveTime/1000) * 1000;
				}
				
				//播放速度为空时，默认为1
				if (this.playerFilters.playState == 'play') {
					//绘制静态图元
					this.creatStaticPel();
					this.playerFilters.sliderTimeout = setTimeout(() => {
						if (this.playerFilters.playState == 'play') {
							//var beginRunTime = new Date().getTime();
							//this.playerFilters.currMoveIndex = this.playerFilters.currMoveIndex + 1;
							
							var flag = this.startMorePlay();
						}
					}, (this.timeDiff > 1000 ? 1000 : this.timeDiff) / this.playerFilters.speed);
				}
				
				// 正在播放 延时执行下一个点
				/*if (this.playerFilters.playState == 'play' && false) {
					this.playerFilters.sliderTimeout = setTimeout(() => {
						if (this.playerFilters.playState == 'play') {
							this.playerFilters.currMoveIndex += this.playerFilters.speed;
							console.log('this.playerFilters.sliderTimeout');
						}
					}, this.timeDiff/ this.playerFilters.speed);
				}*/
				
				return this.$moment(this.playerFilters.currentPlayTime).format('YYYY-MM-DD HH:mm:ss');
			},
			startMorePlay(){
				//	清除定时器
				if(this.playerFilters.sliderTimeout != null) {
					clearTimeout(this.playerFilters.sliderTimeout);
					//this.playerFilters.sliderTimeout = null;
				}
				//	清除定时器
				if(this.playerFilters.startMoreTimeout != null) {
					clearTimeout(this.playerFilters.startMoreTimeout);
					this.playerFilters.startMoreTimeout = null;
				}
				
				if(this.playerFilters.playState != 'play'){
					//	不再播放标示
					/*if(this.playerFilters.sliderTimeout != null) {
						clearTimeout(this.playerFilters.sliderTimeout);
						this.playerFilters.sliderTimeout = null;
					}*/
					return false;
				}
				
				if(this.playerFilters.currMoveIndex >= this.playerFilters.maxMoveIndex){
					//	当前移动位置到达最后一个位置点，停止播放
					
					//	清除定时器
					/*if(this.playerFilters.sliderTimeout != null) {
						clearTimeout(this.playerFilters.sliderTimeout);
						this.playerFilters.sliderTimeout = null;
					}*/
					//	显示开始播放和重播
					this.playerFilters.playState = 'end';
					// 设置播放flag
					this.mapSub.setPlayFlag(false);
					return false;
				}
				
				//滚动条位置 触发change
				//$("#slider").slider("value", currMoveIndex);
				
				//播放速度为空时，默认为1
				//var speedV = $('#speed_num').val() == ''?1:parseInt($('#speed_num').val());
				
				if(this.autoChangeMapFlag){
					// 不同场景，自动切换，重新绘制
					var stopRun = false;
					this.map_track.keySet().forEach((key, n) => {
						if (stopRun) return false;
						var row = this.map_track.get(key);
						if (this.playerFilters.currMoveIndex >= row.points.length - 1) return true;
						if(row.points[this.playerFilters.currMoveIndex + 1].mapId != row.points[this.playerFilters.currMoveIndex].mapId){
							//	清除定时器
							if(this.playerFilters.startMoreTimeout != null) {
								clearTimeout(this.playerFilters.startMoreTimeout);
								this.playerFilters.startMoreTimeout = null;
							}
							let dt = row.points[this.playerFilters.currMoveIndex + 1].t - row.points[this.playerFilters.currMoveIndex].t;
							dt = dt > 1000 ? 1000 : dt;
							//	切换场景，重新绘制
							this.playerFilters.startMoreTimeout = setTimeout(() => {
								// 切换地图
								this.filters.mapId = row.points[this.playerFilters.currMoveIndex + 1].mapId;
								
								let areaId = row.points[this.playerFilters.currMoveIndex + 1].areaId;
								if (this.filters.areaId != areaId) {
									// 切换区域
									this.filters.areaId = areaId;
									
									// 检索 当前区域
									let currArea = this.map_list_areas.get(this.filters.areaId);
									// 切换区域
									this.changeArea(currArea);
								} else {
									// 检索 当前地图
									let currMap = this.map_list_maps.get(this.filters.mapId);
									// 切换区域
									this.changeMap(currMap);
								}
								
								// 触发slider更改事件
								this.playerFilters.currMoveIndex += 1;
								
								var flag = this.creatStaticPel();
								if(flag){
									//this.startMorePlay();
								}
								
							}, dt / this.playerFilters.speed);
							stopRun = true;
							return false;
						}
					});
					if(stopRun){
						var flag = this.creatStaticPel();
						if(flag){
							//this.startMorePlay();
						}
						return false;
					}
				}
				
				this.map_track.keySet().forEach((key, n) => {
					var row = this.map_track.get(key);
					if(this.playerFilters.currMoveIndex >= row.points.length - 1){
						return true;
					}
					if (row.points[this.playerFilters.currMoveIndex].mapId != this.filters.mapId || row.points[this.playerFilters.currMoveIndex + 1].mapId != this.filters.mapId) {
						return true;
					}
					if(row.points[this.playerFilters.currMoveIndex + 1].x - row.points[this.playerFilters.currMoveIndex].x == 0
						&& row.points[this.playerFilters.currMoveIndex + 1].y - row.points[this.playerFilters.currMoveIndex].y == 0){
						//	同一个点不做动画
						return true;
					}
					var pImg = this.mapSub.getPeopleImage(row.points[this.playerFilters.currMoveIndex].type, row.points[this.playerFilters.currMoveIndex].state);
					var points = [];
					points.push({
						x: row.points[this.playerFilters.currMoveIndex].x,
						y: row.points[this.playerFilters.currMoveIndex].y,
						t: row.points[this.playerFilters.currMoveIndex].t,
						mapId: row.points[this.playerFilters.currMoveIndex].mapId,
						type: row.points[this.playerFilters.currMoveIndex].type
					});
					points.push({
						x: row.points[this.playerFilters.currMoveIndex + 1].x,
						y: row.points[this.playerFilters.currMoveIndex + 1].y,
						t: row.points[this.playerFilters.currMoveIndex + 1].t,
						mapId: row.points[this.playerFilters.currMoveIndex + 1].mapId,
						type: row.points[this.playerFilters.currMoveIndex + 1].type
					});
					this.mapSub.creatMovePel(key, {
						userName: row.userName,
						userNo: row.userNo,
						color: row.color,
						showName: row.showName,
						img: pImg,
						points: points
					},this.playerFilters.speed);
					// this.timeDiff/this.playerFilters.speed
				});
				
				// 触发slider更改事件
				this.playerFilters.currMoveIndex += 1;
				
				return true;
			},
			
			/**
             * @Des 播放
             * @Auth
             * @Date 2021/8/24
             */
			playTracks() {
				// 播放状态
				this.playerFilters.playState = 'play';
				// 设置播放flag
				this.mapSub.setPlayFlag(true);
				//绘制静态图元
				this.creatStaticPel();
			},
			/**
             * @Des 暂停
             * @Auth
             * @Date 2021/8/24
             */
			pauseTracks() {
				// 播放状态
				this.playerFilters.playState = 'pause';
				// 设置播放flag
				this.mapSub.setPlayFlag(false);
			},
			/**
             * @Des 重新播放
             * @Auth
             * @Date 2021/8/24
             */
			replayTracks() {
				// 重置播放
				this.resetPlay();
				// 播放状态
				this.playerFilters.playState = 'play';
				// 设置播放flag
				this.mapSub.setPlayFlag(true);
				//	当前移动的位置
				this.playerFilters.currMoveIndex = this.playerFilters.minMoveIndex;
			},
        },
        /**
         * @Des 监听
         * @Auth
         * @Date 2021/8/17
         */
        watch: {

        },

    }
</script>

/* CSS */
<style lang="scss" scoped>
	*{
        box-sizing: border-box;
        color: #e6e6e6;
    }
    .table-item-box {
        height: 100%;
        width: 100%;
        /*padding-left: 260px;*/

		transition: all 0.4s;
    }
    .table-item-box.max-box{
    	padding-left: 30px;
    }

    .el-form-item{
        margin-bottom: 0px;
        margin-right: 0px;
    }

    .el-button--text {
    	padding: 4px 0px;
    	width: 45px;
    	/*text-align: center;*/
		color: #fff;
		background-color: #409EFF;
    }
    .el-button--text:hover {
    	background: #66b1ff;
    }

    .table-item-box.max-box{
        padding-left: 30px;
    }

    /deep/ .el-input__inner{
        font-size: 8px;
        height: 30px;
        line-height: 30px;
        padding: 0 5px;
    }
    /deep/ .el-form-item__label {
		color: #e6e6e6;
	}

    /deep/ .el-button{
        background-color: #03004e;
    }

    /deep/ .el-button:hover {
        background: #222285;
    }

    .page-box {
    	height: 100%;
    	width: 100%;
    	padding-right: 502px;
    	position: relative;

    	transition: all 0.4s;

		* {
			transition: all 0.4s;
		}

    	&.no-items {
    		padding-right: 0px;

    		.map-items-box, .handle-btns-box {
    			right: 0px;
    		}

    		.items-box {
    			width: 0;
    			padding: 0;
    			opacity: 0;
    		}
    	}
    }
    .map-box {
    	height: 100%;
    	width: 100%;
    	/*background-color: #0e5ec0;*/
    	overflow: hidden;

    	.off {
    		display: none;
    	}
    }
    .none-map-item {
    	height: 100%;
    	width: 100%;
    	position: relative;

    	img {
    		position: absolute;
    		top: 0;
    		bottom: 0;
    		left: 0;
    		right: 0;
    		margin: auto;
    	}
    }

    /*==== items 列表 start ====*/
    .items-box {
    	height: 100%;
    	width: 504px;
    	overflow: hidden;
    	overflow-y: auto;
    	padding: 5px;
    	border: 1px solid #409eff;

    	position: absolute;
    	top: 0;
    	bottom: 0;
    	right: 0;
    	margin: auto;

    }

    .el-row {
		margin: 0px;
		padding: 0px;
		margin-bottom: 5px;
	}

	.el-col {
		border-radius: 4px;
		padding: 5px;
		background: #0e5ec0;
	}
	.item-title {
		white-space: nowrap;
	    overflow: hidden;
	    text-overflow: ellipsis;
	    display: block;
	}
	.item-btns-box {
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		height: 30px;

		i {
			cursor: pointer;
			padding: 4px;
			border-radius: 4px;
			
			&:hover {
				border-color: #409eff;
			}
		}
	}
	/*==== items 列表 end ====*/

    /*======== 区域、地图 列表  start ========*/
	.area-items-box, .map-items-box {
		font-size: 8px;
		position: absolute;
	    top: 10px;
	    left: 10px;
	    overflow: visible;

	    ul {
	    	list-style: none;
		    padding: 5px;
		    margin: 0;
		    max-height: 400px;
		    background-color: #0e5ec0;
		    border: 1px solid #20a0ff;
			border-radius: 4px;
			overflow: hidden;
			overflow-y: auto;

		    /* ==== 滚动条  ==== */
			&::-webkit-scrollbar {
				width: 5px;
				height: 5px;
				background-color: #343d81;
				border-radius: 2px;
			}
			/*定义滑块 内阴影+圆角*/
			&::-webkit-scrollbar-thumb {
				background-color: #5975af;
				border-radius: 2px;
			}
			/* ==== 滚动条  ==== */
			&::-moz-scrollbar {
				width: 5px;
				height: 5px;
				background-color: #343d81;
				border-radius: 2px;
			}
			/*定义滑块 内阴影+圆角*/
			&::-moz-scrollbar-thumb {
				background-color: #5975af;
				border-radius: 2px;
			}

		    li {
		    	padding: 5px;
		    	cursor: pointer;
		    	border-radius: 2px;
		    	width: 80px;
		    	white-space: nowrap;
			    overflow: hidden;
			    text-overflow: ellipsis;
			    display: block;
			    border: 1px solid rgba(0,0,0,0);
		    	&:hover {
		    		border-color: #409eff;
		    	}
		    	&.on {
		    		background-color: #1b51a2;
		    		border-color: #409eff;
		    		color: #fff;
		    	}
		    }
	    }
   }

	.map-items-box {
		top: auto;
		bottom: 10px;
		left: auto;
		right: 544px;
	}
	/*======== 区域、地图 列表  end ========*/

	/*======== 操作按钮 集合  start ========*/
	/deep/.handle-btns-box {
		position: absolute;
	    top: 10px;
	    right: 544px;
	    font-size: 0;

	    .el-button {
	    	font-size: 16px;
	    	height: 30px;
	    	line-height: 30px;
	    	width: 30px;
	    	text-align: center;
	    	padding: 0;

	    	&.on {
	    		background-color: #409EFF;
	    	}
	    	
	    	i {
	    		line-height: 30px;
	    	}

	    }/* .el-button */
	}/* .handle-btns-box */
	/*======== 操作按钮 集合  end ========*/
	
	/*============= 播放器 start =============*/
	/*====== 含有播放器 ======*/
	.player-contral {
		.map-box {/*height: calc(100% - 45px);*/ height: calc(100% - 55px);}
		.map-items-box {/*bottom: 55px;*/bottom: 55px;}
		
	}
	
	/*====== 正在播放 ======*/
	.track-playing {
		.area-items-box, .map-items-box {
			ul {
				li {
					cursor: not-allowed;
					&:hover:not(.on) {
						border-color: rgba(0,0,0,0);
					}
				}
			}
		}
	}
	
	.player-contral-box {
		height: 40px;
	    /*border: 1px solid #20a0ff;*/
	    position: absolute;
	    left: 10px;
	    right: 10px;
	    bottom: -10px;
	}
	.contral-items-box {
		height: 100%;
		width: 100%;
		position: relative;
		padding-left: 40px;
	}
	
	.contral-btns-box {
		font-size: 24px;
		width: 40px;
		height: 100%;
		position: absolute;
		left: 0px;
		line-height: 38px;
		text-align: center;
		cursor: pointer;
		
		transition: all 0.4s;
		
		&:hover {
			transform: scale(1.2);
		}
		/deep/ .iconfont {
			font-size: 20px;
			position: relative;
			top: -2px;
		}
	}
	
	.time-item-start, .time-item-end {
		float: left;
		line-height: 38px;
		font-size: 12px;
		width: 120px;
	}
	.time-item-end {
		float: right;
	}
	.time-item-curr {
		position: absolute;
		top: -6px;
		left: 0px;
		right: 20px;
		font-size: 12px;
		width: 120px;
		margin: auto;
	}
	
	.speed-item-box {
		text-align: center;
		line-height: 18px;
		border: 1px solid #1462b0;
		cursor: pointer;
		border-radius: 4px;
		position: absolute;
		top: -10px;
		left: 160px;
		right: 0px;
		font-size: 12px;
		width: 50px;
		margin: auto;
		user-select:none;
		
		&:hover {
			background-color: #1b51a2;
			border-color: #20a0ff;
		}
	}
	
	.slider-item-box {
		height: 100%;
		width: calc(100% - 260px);
		/*padding-top: 6px;*/
		margin: 0 auto;
	}
	/*============= 播放器 start =============*/
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Location/LocationTrackMap.vue